export enum PermissionsScope {
  TAX_SUPERVISOR = "TAX_SUPERVISOR",
  ADMIN = "ADMIN",
  CLERK = "CLERK",
  ACCOUNTING = "ACCOUNTING",
  READONLY = "READONLY",
  INVALID = "INVALID",
}
